module.exports = __webpack_public_path__ + "media/occult bleeding.cbc651c3.wav";